import { useNavigate } from 'react-router-dom';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	DataBoxConfirmModalType,
	useDataBoxMessageDetailContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Dialog, LayoutGap, Icon } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

const ExclamationIcon = () => (
	<Icon
		name="exclamation-triangle-fill"
		type="components"
		color="error"
	/>
);

const CancelButton = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const { setConfirmModal } = useDataBoxMessageDetailContext();
	return (
		<Button
			nativeType="button"
			color="primary"
			type="base"
			size="m"
			onClick={() => setConfirmModal(null)}
			aria-label={tn('zpravy.zrusit')}>
			{tn('zpravy.zrusit')}
		</Button>
	);
};

export const DataBoxMessageConfirmModal = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const {
		dataBoxId,
		folderType,
		messageOperations,
		confirmModal,
		setConfirmModal,
		loadingItems,
	} = useDataBoxMessageDetailContext();

	const navigate = useNavigate();

	const redirect = () => {
		navigate(
			pageRouteResolver('datove-schranky.schranka', {
				dataBoxId,
				folderType,
			})
		);
	};

	return (
		<>
			{confirmModal === DataBoxConfirmModalType.removeMessage && (
				<Dialog
					isOpen={
						!!confirmModal &&
						DataBoxConfirmModalType.removeMessage.includes(confirmModal)
					}
					onClose={() => setConfirmModal(null)}
					icon={<ExclamationIcon />}
					title={<h3>{tn('zpravy.smazani-kopie-zpravy')}</h3>}
					footer={
						<>
							<CancelButton />
							<Button
								nativeType="button"
								color="error"
								type="outlined"
								size="m"
								isLoading={loadingItems.removePermanently}
								onClick={() =>
									messageOperations.handleDeleteMessage(true, redirect)
								}
								isDisabled={!!loadingItems.removePermanently}
								aria-label={tn('zpravy.trvale-smazat')}>
								{tn('zpravy.trvale-smazat')}
							</Button>
							<Button
								nativeType="button"
								color="error"
								type="solid"
								size="m"
								isLoading={loadingItems.remove}
								onClick={() =>
									messageOperations.handleDeleteMessage(false, redirect)
								}
								isDisabled={!!loadingItems.remove}
								aria-label={tn('zpravy.smazat')}>
								{tn('zpravy.smazat')}
							</Button>
						</>
					}>
					<LayoutGap gap="s">
						<p>{tn('zpravy.opravdu-chcete-smazat')}</p>
						<p>
							<strong>{tn('zpravy.smazanim-do-kose')}</strong>{' '}
							{tn('zpravy.zpravu-najdete-slozky')}
						</p>
						<p>{tn('zpravy.kopii-zpravy-muzete-smazat')}</p>
					</LayoutGap>
				</Dialog>
			)}

			{confirmModal === DataBoxConfirmModalType.removeMessagesPermanently && (
				<Dialog
					isOpen={
						!!confirmModal &&
						DataBoxConfirmModalType.removeMessagesPermanently.includes(
							confirmModal
						)
					}
					onClose={() => setConfirmModal(null)}
					icon={<ExclamationIcon />}
					title={<h3>{tn('zpravy.trvale-smazani-zpravy')}</h3>}
					footer={
						<>
							<CancelButton />
							<Button
								nativeType="button"
								color="error"
								type="solid"
								size="m"
								isLoading={loadingItems.removePermanently}
								iconStart={
									!loadingItems.removePermanently && (
										<Icon
											type="templates"
											name="trash"
										/>
									)
								}
								onClick={() =>
									messageOperations.handleDeleteMessage(true, redirect)
								}
								isDisabled={!!loadingItems.removePermanently}
								aria-label={tn('zpravy.trvale-smazat')}>
								{tn('zpravy.trvale-smazat')}
							</Button>
						</>
					}>
					<LayoutGap gap="s">
						<p>{tn('zpravy.opravdu-trvale-smazat')}</p>
						<p>{tn('zpravy.trvale-smazane-neobnovite')}</p>
					</LayoutGap>
				</Dialog>
			)}
		</>
	);
};
